import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './ColorPaletteGenerator.css'
import { generatePalette, toCssVariables } from './utils/colorPalette'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const HARMONY_OPTIONS = [
  { key: 'complementar', label: 'Complementar' },
  { key: 'analoga', label: 'Análoga' },
  { key: 'triade', label: 'Tríade' },
  { key: 'tetrade', label: 'Tétrade' },
]

const ColorPaletteGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de Paleta de Cores Harmônica | jarder.dev',
    description:
      'Gere paletas complementares, análogas, tríade ou tétrade a partir ' +
      'de uma cor base, e exporte como variáveis CSS. Grátis.',
  })

  const [baseColor, setBaseColor] = useState('#ff7a45')
  const [harmony, setHarmony] = useState('analoga')

  const palette = useMemo(() => generatePalette(baseColor, harmony), [baseColor, harmony])

  const copyCss = () => {
    navigator.clipboard.writeText(`:root {\n${toCssVariables(palette)}\n}`)
    trackEvent('tool_copy', { tool: 'color_palette' })
  }

  const generate = (h) => {
    setHarmony(h)
    trackEvent('tool_generate', { tool: 'color_palette', harmony: h })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de Paleta de Cores Harmônica</h1>
      <p className="tool-disclaimer">
        Escolha uma cor base e o tipo de harmonia: as demais cores são
        calculadas pela roda de cores (matiz, saturação e luminosidade).
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="base-color">Cor base</label>
          <div className="contrast-color-row">
            <input type="color" value={baseColor} onChange={(e) => setBaseColor(e.target.value)} />
            <input
              id="base-color"
              type="text"
              value={baseColor}
              onChange={(e) => setBaseColor(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="tool-row" style={{ marginBottom: 20 }}>
        {HARMONY_OPTIONS.map((opt) => (
          <button
            key={opt.key}
            type="button"
            className={`tool-button ${harmony === opt.key ? '' : 'tool-button-secondary'}`}
            onClick={() => generate(opt.key)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      <div className="palette-swatches">
        {palette.map((color, i) => (
          <div className="palette-swatch" key={i} style={{ background: color }}>
            <span>{color}</span>
          </div>
        ))}
      </div>

      <button type="button" className="tool-button tool-button-secondary" onClick={copyCss} style={{ marginTop: 16 }}>
        Copiar como variáveis CSS
      </button>

      <div className="tool-info-section">
        <h2>O que muda entre as harmonias</h2>
        <p>
          <strong>Complementar</strong> usa a cor oposta na roda de
          cores, criando alto contraste. <strong>Análoga</strong> pega
          cores vizinhas, gerando combinações suaves e harmônicas.{' '}
          <strong>Tríade</strong> distribui três cores a 120° uma da
          outra, equilibrando contraste e harmonia. <strong>Tétrade</strong>{' '}
          usa quatro cores em dois pares complementares, para paletas
          mais ricas e variadas. O resultado pode ser exportado direto
          como variáveis CSS para usar no seu projeto.
        </p>
      </div>
    </div>
  )
}

export default ColorPaletteGenerator
